import type { ToolCall } from "../component/types/toolCall";

export const isToolCallCompleted = (toolCall: ToolCall) =>
  toolCall.executionStatus === "success" ||
  toolCall.executionStatus === "error" ||
  toolCall.executionStatus === "rejected";

export const areAllToolCallsCompleted = (toolCalls: ToolCall[]) =>
  toolCalls.length > 0 && toolCalls.every(isToolCallCompleted);

export const getPendingSubmissionIndexes = (toolCalls: ToolCall[]) =>
  toolCalls
    .map((toolCall, idx) =>
      isToolCallCompleted(toolCall) &&
      toolCall.outputSubmissionStatus === "pending"
        ? idx
        : -1,
    )
    .filter((idx) => idx !== -1);

export const getPendingSubmissionToolCalls = (toolCalls: ToolCall[]) =>
  toolCalls.filter(
    (toolCall) =>
      isToolCallCompleted(toolCall) &&
      toolCall.outputSubmissionStatus === "pending",
  );

export const setToolCallsSubmissionStatus = (
  toolCalls: ToolCall[],
  indexes: number[],
  status: "inProgress" | "success" | "error",
) => {
  indexes.forEach((idx) => {
    toolCalls[idx].outputSubmissionStatus = status;
  });
};
